var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-list-doc';
                    var viewUrl = 'sprite.svg#view-icon-list-doc';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 308 308',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };